/**
 * Local device identity only — "which paired device is this browser/tablet" —
 * not a fake shared backend. The actual pairing + order data all live in
 * Postgres; this just remembers which device row belongs to this physical
 * display across reloads.
 *
 * Stores the FULL pairing descriptor (not just the pairing code) — mirrors
 * apps/pos's PairedDevice. Saved from the pairing response, so the display knows who it
 * is from localStorage alone, before (and without) any sync.
 */
export interface PairedKdsDevice {
  deviceId: string;
  businessId: string;
  storeId: string;
  storeName: string;
  registerName: string;
  pairingCode: string;
}

const DEVICE_KEY = "cliqsuite_kds_device_v2";

export function readPairedKdsDevice(): PairedKdsDevice | null {
  try {
    const raw = localStorage.getItem(DEVICE_KEY);
    return raw ? (JSON.parse(raw) as PairedKdsDevice) : null;
  } catch {
    return null;
  }
}

export function writePairedKdsDevice(device: PairedKdsDevice | null): void {
  try {
    if (device === null) localStorage.removeItem(DEVICE_KEY);
    else localStorage.setItem(DEVICE_KEY, JSON.stringify(device));
  } catch {
    // ignore (private browsing / storage disabled)
  }
}
